import React, { Component } from 'react';
import {connect} from 'react-redux';
import {cekCookies} from '../../../../actions';
import __ from 'lodash';
import Loader from '../../../Loader';
import LoaderModal from '../../../modal/LoaderModal';
import Navbar from '../../navbar/Navbar';
import Sidebar from '../../sidebar/Sidebar';
import { CONFIG } from '../../../../config';
import accountManagement from '../../../../apis/accountManagement';
import { Alert, Form, Row, Col } from 'react-bootstrap';

class KoreksiEssay extends Component {
    constructor(props) {
        super(props);
        this.state = {  
            isFetching: false,
            isLoading: false,            
            alertShow: false,
            resMessage: null,
            idSubHeader: props.match.params.idsubheader,
            idSiswa: props.match.params.idsiswa,
            listSoal: [],
            maxSkor: 100,
            skorEssay: 0,
            skorMultiple: 0,
            skorTotal: 0,
            prosentaseEssay: 0,     
            lastTarget: null
        }
        this.handleChange = this.handleChange.bind(this)
    }
    async componentDidMount() { 
        this.setState({ isFetching: true});
        await this.props.cekCookies(); 
        console.log(this.props)
        if(!__.isEmpty(this.props.account)) {
            this.fetchSoal(this.props.match.params.idsubheader)
        } 
        this.setState({ isFetching: false});   
        
        (function () {
            var script = document.createElement("script");
            script.type = "text/javascript";  
            script.src = "https://s3edubucket.s3-ap-southeast-1.amazonaws.com/javascripts/MathJax-2.7.5/MathJax.js?config=TeX-MML-AM_CHTML";
        
            var config = 'MathJax.Hub.Config({' +
                'extensions: ["tex2jax.js"],' +
                'jax: ["input/TeX","output/HTML-CSS"]' +
                '});' +
                'MathJax.Hub.Startup.onload();';
        
            if (window.opera) {
                script.innerHTML = config
            } else {
                script.text = config
            }
        
            script.addEventListener('load', function() {
                window.MathJax.Hub.Queue(["Typeset",window.MathJax.Hub, ""]);
            })
        
            document.getElementsByTagName("head")[0].appendChild(script);
        })();
        
    }
    fetchSoal = async(id) => {
        this.setState({ isLoading: true, listHw:[] });
        const res = await accountManagement.get(CONFIG.CBT_GET_ESSAY_SISWA + id )
            .catch(function(error){ console.log(error) });
        
        if (res) {
            if(res.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({ 
                    listSoal: res.data.data.arrayJawaban,
                    skorEssay: res.data.data.skorEssay,
                    skorMultiple: res.data.data.skorMultiple,
                    skorTotal: res.data.data.skorTotal, 
                    prosentaseEssay: res.data.data.prosentaseEssay, 
                });  
            } else {
                this.setState({ listSoal: [] });  
            }            
            this.setState({ isLoading: false});          
        }
        window.MathJax.Hub.Queue(["Typeset",window.MathJax.Hub, ""]);
    } 

    handleChange = (evt) => {
        const {listSoal, maxSkor} = this.state;
        const re = /^[0-9\b]+$/;      
        const value = evt.target.value;
        const index = evt.target.id; 
        if (value === '' || re.test(value) && Number(value) <= maxSkor) {   
            listSoal[index].nilaiEssay = value;            
            this.setState({ 
                listSoal: listSoal
            }) 
        } 
    }

    onSubmit = async(e) => {
        e.preventDefault()
        const {listSoal, idSubHeader, prosentaseEssay} = this.state;
        const totalEssay = listSoal.reduce((total, item) => total + parseInt(item.nilaiEssay, 10), 0); 
        if(totalEssay > 100) {
            this.setState({
                alertShow: true,
                resMessage: 'Skor Essay tidak bisa > 100 ...!!'
            })
            e.preventDefault()
        } else {
            if(window.confirm('Konfirmasi Simpan ?')) {
                var array = []
                listSoal.map(item => 
                    array = [...array, {
                        idDetailCbt: item.idDetailCbt,
                        idSoalHub: item.idSoalHub,
                        nilaiEssay: item.nilaiEssay
                    }]
                )
                //this.setState({isFetching: true})
                const dataSend = {
                    idSubHeader: idSubHeader,
                    idSiswa: this.state.idSiswa,
                    prosentaseEssay: prosentaseEssay,
                    skor: this.state.skorTotal,
                    skorEssay: totalEssay,
                    skorMultiple: this.state.skorMultiple,
                    arrayJawaban: array
                }
                const res = await accountManagement.post(CONFIG.EXAM_KOREKSI_ESSAY, dataSend).catch(function(error){ console.log(error) })
                if(res){
                    if(res.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){       
                        this.props.history.push({
                            pathname: '/reporthw',
                            state: this.props.location.state
                        })
                        
                    } else {
                        this.setState({ alertShow: true, resMessage: res.data.errorSchema.errorMessage})
                        window.scrollTo(0, 0)
                    }
                    this.setState({ isFetching: false });
                } 
            }
             
        }

        
    }

    handleBack = () => {
        if(window.confirm('Konfirmasi Keluar ?')) {
            this.props.history.push({
                pathname: '/reporthw',
                state: this.props.location.state
            })
        }
    }    

    

    render() { 
        const {isLoading,listSoal, maxSkor} = this.state;
        const skorEssay = listSoal.reduce((total, item) => total + parseInt(item.nilaiEssay, 10), 0);
        return (  
            <div className="wrapper">
                <LoaderModal isFetching={this.state.isFetching}/> 
                <Sidebar account={this.props.account}/>
                <div id="content" style={{paddingBottom: '50px'}}>
                    <Navbar title={'Koreksi Essay'}/> 
                    {this.loadAlert()}
                    {isLoading ? <Loader /> :
                    <div className="container-fluid">  
                        <Form onSubmit={this.onSubmit}> 
                        <Row style={{marginBottom: '10px'}}>
                            <Col>
                            <span>Skor Pilihan Ganda: {this.state.skorMultiple} / 
                                Skor Essay: {this.state.skorEssay}</span> 
                            </Col>
                            <Col> 
                                <div className="pull-right">                                
                                    <small>akumulasi nilai: </small>{skorEssay > 100 ? <strong className="text-danger">{skorEssay}</strong> : <strong>{skorEssay}</strong>}
                                    <small>&nbsp;/ max: </small>{maxSkor}<i className="text-danger">*</i>
                                </div>
                            </Col>
                        </Row>
                        
                        <table className="table">
                            <thead>
                                <th>No</th>
                                <th>Pertanyaan</th>
                                <th>Skor</th>
                            </thead>
                            <tbody>
                            {listSoal.map((soal,i) => 
                                <tr key={i}>
                                    <td width="8px" ><p>{i+1}.</p></td>
                                    <td>                                                                                
                                        <span dangerouslySetInnerHTML={{__html: soal.pertanyaan}}></span>
                                        <div >
                                            <p style={{marginTop: '5px', marginLeft: '5px', fontWeight: 'bolder'}}>Jawaban Siswa: </p>
                                            {soal.jawabanSiswa === null ? 
                                            <p className="text-info"><i> -- siswa tidak mengerjakan -- </i></p> :
                                            <span dangerouslySetInnerHTML={{__html: soal.jawabanSiswa}}></span>
                                            }
                                        </div>
                                    </td>                                    
                                    <td width="10%">                                                                                
                                        <input type="text" className="form-control" id={i} maxLength="3"
                                            value={soal.nilaiEssay}
                                            onChange={this.handleChange} onFocus={this.handleBlur}
                                            required/>                                        
                                    </td>
                                </tr>
                            )} 
                            </tbody> 
                        </table>  

                        <Row>
                            <Col>
                                <button type="button" className="btn btn-danger" onClick={() => this.handleBack()}>Batal</button>
                            </Col>

                            <Col>
                            <button className="btn btn-primary pull-right ">Simpan</button>
                            </Col>
                        </Row>
                        </Form>
                    </div>
                    
                    }
                </div>
            </div>        
        );
    }

    loading = () =>{
        if(this.state.isLoading){
            return(
                <Loader />
            )
        }
    }
    loadAlert = () => {
        const {alertShow } = this.state;
      
        if (alertShow) {
          return (
            <Alert variant="warning" onClose={() => this.setState({ alertShow: false })} dismissible>   
                <strong>{this.state.resMessage}</strong>
            </Alert>
          );
        } 
    }  
}

const mapStateToProps = (state) => {
    return{
        account: state.account       
    };
}

export default connect(mapStateToProps, {cekCookies})(KoreksiEssay); 